import { useNavigate } from 'react-router-dom'
import { InvoiceProcessing } from '../components/InvoiceProcessing'
import { type ReviewContext, createReviewSession } from '../lib/reviewSessions'

export function InvoicesPage() {
  const navigate = useNavigate()

  const handleInvoiceReview = (invoiceId: string, context?: ReviewContext) => {
    sessionStorage.setItem('processingReturnUrl', window.location.pathname + window.location.search)

    const searchParams = new URLSearchParams()

    if (context) {
      const sessionId = createReviewSession(context)
      searchParams.set('sessionId', sessionId)
    }

    const queryString = searchParams.toString()
    const url = queryString ? `/review/${invoiceId}?${queryString}` : `/review/${invoiceId}`
    navigate(url)
  }

  return (
    <div className="page-shell">
      <InvoiceProcessing onInvoiceReview={handleInvoiceReview} />
    </div>
  )
}
